import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'JobCategoryPipe'})

export class JobCategoryPipe implements PipeTransform  {

  private unknownType = 'Unknown';
  private jobCategory = {H : 'Home', B: 'Business' };

  constructor(){}

  transform(key) {
      return (this.jobCategory[key]) ? this.jobCategory[key] : this.unknownType;
  }
}